import useKSClientPdfSplitViewModel from './KSClientPdfSplitViewModel'
import { toast } from 'react-toastify'
import cn from 'clsx'

import KSClientPdfSplitLogsList from './KSClientPdfSplitLogsList'
import KSClientPdfSplitImageCard from '../widgets/KSClientPdfSplitImageCard'
import KSClientPdfSplitImageModal from '../widgets/KSClientPdfSplitImageModal'
import KSClientPdfSplitDownloadButton from '../widgets/KSClientPdfSplitDownloadButton'
import ProgressBar from '@components/shared/ProgressBar'
import { MdCloudUpload, MdRefresh, MdClear } from 'react-icons/md'

const KSClientPdfSplit = () => {
    
    const vm = useKSClientPdfSplitViewModel()
    
    return (
        
        <div id="KSClientPdfSplit" className="p-3 pt-0">
            
            <div className="flex gap-4">
                
                <div className="left-panel border-r border-accent p-4 pt-0 shrink-0 w-[22rem]">
                    
                    <input
                        ref={vm.fileInputRef}
                        className="mb-4 border border-gray-300 rounded p-2 hidden"
                        type="file"
                        accept="application/pdf"
                        disabled={vm.loading}
                        onChange={vm.handleFileChange} />
                    <div
                        className="flex items-center content-center gap-4
                            px-4 py-3 rounded bg-secondary/20 hover:bg-accent/70 cursor-pointer"
                        onClick={() => vm.fileInputRef.current.click()}>
                        <div><MdCloudUpload className="text-2xl" /></div>
                        <div className="text-sm">
                            {vm.file?.name || 'Select a PDF file'}
                        </div>
                    </div>
                    
                    <div className="my-4">
                        <ProgressBar
                            className="bg-gray-300"
                            barClassName="bg-accent"
                            max={vm.splitProgressMax}
                            value={vm.splitProgressValue} />
                    </div>
                    
                    <div className="flex justify-between gap-2 my-4">
                        <KSClientPdfSplitDownloadButton
                            fileName={vm.file?.name}
                            imagePayloads={vm.blobUris} />
                        <button
                            className="btn btn-primary"
                            title="Clear file & pages"
                            disabled={!vm.file || vm.loading}
                            onClick={vm.clearFile}>
                            <MdClear className="text-xl" />
                        </button>
                        <button
                            className="btn btn-primary"
                            title="Run Again"
                            disabled={!vm.file || vm.loading}
                            onClick={() => vm.renderSplitFile()}>
                            <MdRefresh className="text-xl" />
                        </button>
                    </div>
                    
                    <KSClientPdfSplitLogsList
                        logs={vm.logs}
                        loading={vm.loading} />
                
                </div>
                
                <div className="w-full">
                    <div className={cn('w-full', vm.pageGridColsMap[vm.blobUris?.length || 1] || 'grid-cols-6', {
                        'grid gap-4': vm.blobUris?.length > 1,
                    })}>
                        {!vm.blobUris && (
                            <KSClientPdfSplitImageCard
                                className="!w-96"
                                src=""
                                alt=""
                                title="Choose a PDF to begin"
                                onClick={() => toast.warn('Choose a PDF first')} />
                        )}
                        {vm.blobUris?.map((it, i) => (
                            <KSClientPdfSplitImageCard
                                className={cn({
                                    '!w-96': vm.blobUris?.length < 6,
                                })}
                                key={`blob-${i}`}
                                src={it.blob}
                                alt={`${it.fileName}??`}
                                title={it.fileName}
                                onClick={() => vm.setModalImage(it)} />
                        ))}
                    </div>
                </div>
            
            </div>
            
            {vm.modalImage && (
                <KSClientPdfSplitImageModal
                    src={vm.modalImage.blob}
                    title={vm.modalImage.fileName}
                    onClose={() => vm.setModalImage(null)} />
            )}
        
        </div>
        
    )
    
}

export default KSClientPdfSplit
